import React from "react";
import PropTypes from "prop-types";

const style = {
  width: "100%",
  aspectRatio: "16 / 9",
};
const VimeoPreview = ({ videoId }) => (
  <div className="event-details--video-preview">
    <iframe
      style={style}
      src={`https://player.vimeo.com/video/${videoId}`}
      frameBorder="0"
      allow="autoplay; fullscreen"
      allowFullScreen
      title="Vimeo Video Preview"
    ></iframe>
  </div>
);

VimeoPreview.propTypes = {
    videoId: PropTypes.string,
};

export default VimeoPreview;
